import moment from "moment";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Tooltip from "../tooltip/tooltip";
import util from "../util/util";

import { Link } from "react-router";

export default function PodDetailPod(props) {
  const [pod, setPod] = useState({});
  const [podStatus, setPodStatus] = useState(0);
  const [displayErrors, setDisplayErrors] = useState("");
  const [url, setUrl] = useState("");
  const [filename, setFilename] = useState("");
  const [podStatusLabel, setPodStatusLabel] = useState("");
  const [tooltipMessage, setTooltipMessage] = useState("");

  useEffect(() => {
    const pod = props.pod;
    const url = pod.source_file || pod.source_url || "";
    let filename = url ? url.split(`/`).slice(-1) : "";
    if (filename && filename[0].length > 44) {
      filename = filename[0].substring(0, 44);
    }
    const podStatusLabel = util.returnPodStatus(props.podStatus) || "";

    setPod(pod);
    setPodStatus(props.podStatus);
    setDisplayErrors(util.formatVideoError(props.podStatusMessage));
    setUrl(url);
    setFilename(filename);
    setPodStatusLabel(podStatusLabel);
    setTooltipMessage(getTooltipMessage(podStatusLabel));
  }, [props]);

  const getTooltipMessage = podStatusLabel => {
    let tooltipMessage = null;

    if (podStatusLabel === "Processing") {
      tooltipMessage =
        "Pod must complete ingestion<br />before it can be scheduled.";
    } else if (podStatusLabel === "Ready") {
      tooltipMessage = "Successfully ingested.<br />This pod can be scheduled.";
    } else if (podStatusLabel === "Failed") {
      tooltipMessage =
        "Failed ingestion due to the<br />source not meeting requirements.";
    }

    return tooltipMessage;
  };

  return (
    <div>
      <div className="row">
        <div className="col-xs-7 col-sm-8">
          <h4 className="page__title">{pod.name}</h4>
        </div>
        <div className="col-xs-5 col-sm-4">
          {podStatus !== 4 ? ( // 4 == Deleted
            <p className="page__actions">
              <Link
                to={util.returnPodFormUrl(pod.id)}
                className="btn btn-primary"
              >
                <i className="fa fa-pencil" aria-hidden="true"></i>
                Edit Pod
              </Link>
              <button
                id="pod-detail__delete"
                className="btn btn-danger"
                onClick={() => props.deletePod(pod)}
              >
                <i className="fa fa-trash-o" aria-hidden="true"></i>
                Delete Pod
              </button>
            </p>
          ) : null}
        </div>
      </div>
      <hr />
      <div className="row">
        <div className="col-sm-6 col-sm-push-6">
          <video src={url} controls></video>
        </div>

        <div className="col-sm-6 col-sm-pull-6">
          <h4 className="page__header">Pod Name</h4>
          <p>{pod.name}</p>

          <h4 className="page__header">File Name</h4>
          <p>
            <a href={url} title={filename} className="pod-detail__url">
              {filename}
            </a>
          </p>

          <div className="row pod-detail__row--content">
            <div className="col-xs-4">
              <h4 className="page__header">
                Status&nbsp;
                <i
                  data-tip={tooltipMessage}
                  data-for="podDetailPodStatus"
                  className="glyphicon glyphicon-question-sign"
                  aria-hidden="true"
                ></i>
              </h4>
              <Tooltip id="podDetailPodStatus" offset_top={"-6"} />
              <p
                className={
                  podStatusLabel === "Processing"
                    ? "pod-detail__processing"
                    : ""
                }
              >
                {podStatusLabel}
              </p>
            </div>
            <div className="col-xs-4">
              <h4 className="page__header">Uploaded</h4>
              <p>{moment(pod.created).format(util.dateFormatHumanLong)}</p>
            </div>
            <div className="col-xs-4">
              <h4 className="page__header">To Expire</h4>
              <p>
                {pod.expiration_date === null
                  ? `Not Set`
                  : moment(pod.expiration_date).format(
                      util.dateFormatHumanLong
                    )}
              </p>
            </div>
            {displayErrors.length ? (
              <div className="col-xs-12">
                <div className="page__status-message">
                  <ul>
                    {displayErrors.map((errorMessage, i) => (
                      <li key={errorMessage}>{errorMessage}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ) : null}
          </div>

          <h4 className="page__header">Description</h4>
          <p>{pod.description || <em>None</em>}</p>
        </div>
      </div>
      <hr />
      <div className="row">
        <div className="col-sm-12">
          <div className="table-responsive">
            <table className="table table-striped table-bordered table-hover">
              <colgroup>
                <col style={{ width: `25%` }}></col>
                <col style={{ width: `15%` }}></col>
                <col style={{ width: `20%` }}></col>
                <col style={{ width: `10%` }}></col>
                <col style={{ width: `10%` }}></col>
                <col style={{ width: `10%` }}></col>
                <col style={{ width: `10%` }}></col>
              </colgroup>
              <thead>
                <tr>
                  <th>Element ID</th>
                  <th>Protrack ID</th>
                  <th>Client Name</th>
                  <th>Spot Name</th>
                  <th>Tape</th>
                  <th>Order</th>
                  <th>Duration</th>
                </tr>
              </thead>
              <tbody>
                {!(pod.elements && pod.elements.length) ? (
                  <tr>
                    <td colSpan="7">
                      <em>No element metadata.</em>
                    </td>
                  </tr>
                ) : (
                  pod.elements.map((element, index) => {
                    return (
                      <tr key={element.id}>
                        <td>
                          <strong>{element.element_id}</strong>
                        </td>
                        <td>{element.protrack_id}</td>
                        <td>{element.client_name}</td>
                        <td>{element.spot_name}</td>
                        <td>{element.tape}</td>
                        <td>{element.order}</td>
                        <td>{element.duration}</td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      &nbsp;
      <div className="row">
        <div className="col-sm-6">
          <h4 className="page__header">Last Changed By</h4>
          <p>
            <em>Not available in the API (yet).</em>
          </p>
        </div>
        <div className="col-sm-6">
          <h4 className="page__header">Change Log</h4>
          <p>
            <Link to={util.returnChangeLogDetailUrl(`pods.pod`, pod.id)}>
              View Change Log
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}

PodDetailPod.propTypes = {
  pod: PropTypes.object,
  podStatus: PropTypes.number,
  podStatusMessage: PropTypes.string,
  deletePod: PropTypes.func
};
